import { Component, OnInit } from '@angular/core';
import { TipoArchivo } from '../../../models/Archivocaso';
import { EstadoRefinamiento, Refinamiento } from '../../../models/Refinamiento';
import { hideLoading, showLoading } from '../../../redux/actions/loading.actions';
import { isFileImage } from '../../../utilities/FileUtilities';
import { LoadingState } from '../../../redux/reducers/loading.reducer';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { RefinamientosapiService } from '../../../services/refinamientosapi.service';
import { ArchivorefinamientoapiService } from '../../../services/archivorefinamientoapi.service';

@Component({
    selector: 'app-enviarresultadosref',
    templateUrl: './enviarresultadosref.component.html',
    styleUrls: ['./enviarresultadosref.component.scss'],
    standalone: false
})
export class EnviarresultadosrefComponent implements OnInit {
  refinamiento: Refinamiento;
  error: boolean;
  comprobante: any;
  pdfData: any;
  urlComprobante: any;


  constructor(
    private actRoute: ActivatedRoute,
    private apiArchivo: ArchivorefinamientoapiService,
    private api: RefinamientosapiService,
    private router: Router,
    private storeLoading: Store<LoadingState>
  ) {
    this.actRoute.params.subscribe(data => {
      if (data.id) {
        // console.log(data.id);
        this.getRefinamiento(data.id);
      }
    });
  }

  ngOnInit() {
  }
  seleccionarPdf(e) {
    this.pdfData = e.target.files[0];
    var reader = new FileReader();
    if (isFileImage(e.target.files[0])) {

      reader.readAsDataURL(e.target.files[0]); // read file as data url

      reader.onload = (ev) => { // called once readAsDataURL is completed
        this.urlComprobante = reader.result;
      }
    }
  }
  getRefinamiento(id: string) {
    this.storeLoading.dispatch(showLoading({ loadingText: "Obteniendo refinamiento" }));

    this.api.getRefinamiento(id).subscribe(data => {
      if (data) {
        this.refinamiento = data;
        this.error = false;
      } else {
        this.error = true;
      }
      // console.log(data);

      this.storeLoading.dispatch(hideLoading());
    });
  }
  async enviarDatos() {

    // console.log(this.caso);
    this.refinamiento.status = EstadoRefinamiento.PAGO_FINAL_REFINAMIENTO_REALIZADO;
    this.storeLoading.dispatch(showLoading({ loadingText: "Subiendo resultados..." }));
    this.api.resultadosEnviados(this.refinamiento).subscribe(caso => {
      this.refinamiento = caso;
      this.storeLoading.dispatch(hideLoading());
      this.storeLoading.dispatch(showLoading({ loadingText: "Cargando PDF..." }));
      this.enviarPdf();
    }, (error) => {
      console.log(error);
      this.storeLoading.dispatch(hideLoading());
    });

  }
  async enviarPdf() {
    if (this.pdfData) {
      const myFormData = new FormData();
      myFormData.append('file', this.pdfData)
      myFormData.append('tipoArchivo', TipoArchivo.PDF.toString());
      myFormData.append('step', EstadoRefinamiento.REFINAMIENTO_ENTREGADO.toString());
      myFormData.append('identificador', 'pdf-caso');
      // console.log(this.pdfData);
      let data = await this.apiArchivo.enviarFoto(myFormData, this.refinamiento.id).toPromise();
      if (data) {
        // console.log('archivo enviado correctamente');
        this.storeLoading.dispatch(hideLoading());
      }
      this.storeLoading.dispatch(hideLoading());
      // this.redirectToList();
    } else {
      this.storeLoading.dispatch(hideLoading());
      // this.redirectToList();
    }
    this.redirectToList();
  }
  redirectToList() {
    this.router.navigateByUrl('/casos/' + this.refinamiento.caso_id + '/verpaciente');
  }


}
